export type SelectorType = 'id' | 'name'

export interface HandlerRegistration {
    selectorType: SelectorType
    selectorValue: string
    eventType: string
    handlerId: string
}

export class EventRegistry {
    private handlers: Map<string, HandlerRegistration[]> = new Map()

    register(
        selectorType: SelectorType | string,
        selectorValue: string,
        eventType: string,
        handlerId: string
    ): void {
        const key = `${selectorType}:${selectorValue}:${eventType}`

        if (!this.handlers.has(key)) {
            this.handlers.set(key, [])
        }

        this.handlers.get(key)!.push({
            selectorType: selectorType as SelectorType,
            selectorValue,
            eventType,
            handlerId,
        })

        console.log(
            `[EventRegistry] Registered: ${selectorType}="${selectorValue}" on ${eventType}`
        )
    }

    unregister(
        selectorType: SelectorType | string,
        selectorValue: string,
        eventType: string,
        handlerId?: string
    ): void {
        const key = `${selectorType}:${selectorValue}:${eventType}`
        const list = this.handlers.get(key)

        if (!list) return

        if (handlerId) {
            const index = list.findIndex(h => h.handlerId === handlerId)
            if (index !== -1) list.splice(index, 1)
        } else {
            list.length = 0
        }

        if (list.length === 0) {
            this.handlers.delete(key)
        }
    }

    has(blockId: string, eventType: string, blockName?: string): boolean {
        return this.find(blockId, blockName, eventType).length > 0
    }

    find(blockId: string, blockName?: string, eventType?: string): HandlerRegistration[] {
        const results: HandlerRegistration[] = []

        if (eventType) {
            const idKey = `id:${blockId}:${eventType}`
            const idHandlers = this.handlers.get(idKey)
            if (idHandlers) results.push(...idHandlers)

            if (blockName) {
                const nameKey = `name:${blockName}:${eventType}`
                const nameHandlers = this.handlers.get(nameKey)
                if (nameHandlers) results.push(...nameHandlers)
            }
        }

        return results
    }

    getEventTypes(blockId: string, blockName?: string): Set<string> {
        const eventTypes = new Set<string>()

        this.handlers.forEach((_, key) => {
            const [type, value, eventType] = key.split(':')

            if ((type === 'id' && value === blockId) || (type === 'name' && value === blockName)) {
                eventTypes.add(eventType)
            }
        })

        return eventTypes
    }

    clear(): void {
        this.handlers.clear()
    }
}
